import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Divider} from '@vio/atlas/src/components/designSystem/Divider'
import {cssTheme} from '@vio/atlas/themes'

export const MobileContentSpacer = styled.div`
  background-color: ${cssTheme.colors.background.neutral.secondary};
  height: ${cssTheme.layout.spacing.s300};
`

export const DividerComponent = ({isMobile}: {isMobile: boolean}) => {
  return (
    <Box paddingTop="s600" paddingBottom="s600">
      {isMobile ? <MobileContentSpacer /> : <Divider sideMargin="s600" />}
    </Box>
  )
}

export const SpacingWrapper = ({
  children,
  isMobile,
  isCustomLayout
}: {
  children: React.ReactNode
  isMobile: boolean
  isCustomLayout?: boolean
}) => {
  const paddingStyle = isMobile ? 's500' : 's600'
  const shouldRemovePadding = Boolean(isCustomLayout && isMobile)
  return (
    <Box
      paddingLeft={shouldRemovePadding ? undefined : paddingStyle}
      paddingRight={shouldRemovePadding ? undefined : paddingStyle}
    >
      {children}
    </Box>
  )
}
